import { CATEGORY_COLORS, DEFAULT_COLOR, mapColorToPalette } from '@entities/category';
import { CheckVerticalIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface CategoryColorPickerProps {
  value?: string;
  setValue: (value?: string) => void;
}

export const CategoryColorPicker = ({ value, setValue }: CategoryColorPickerProps) => {
  const onColorClick = (color: string) => {
    setValue(color !== value ? color : DEFAULT_COLOR);
  };

  return (
    <div {...stylex.props(styles.container)}>
      <span {...stylex.props(styles.label)}>Цвет</span>

      <div {...stylex.props(styles.colorPicker)}>
        {CATEGORY_COLORS.map((color) => (
          <button
            key={color}
            {...stylex.props(styles.colorButton(mapColorToPalette[color]))}
            onClick={() => onColorClick(color)}
          >
            {value === color && <CheckVerticalIcon />}
          </button>
        ))}
      </div>
    </div>
  );
};
